import { getExtensionSchemaFormatted } from '@/api/schemas'
import { useQuery } from '@tanstack/vue-query'
import { MaybeRef } from '@vueuse/core'
import { computed, unref } from 'vue'
import moment from 'moment'
import { AxiosError } from 'axios'
import { CustomFieldsSchema } from '@/models/types/custom-fields-schema'

export function useGetExtensionSchema(extensionSchemaId: MaybeRef<number | null | undefined>) {
  const computedExtensionSchemaId = computed(() => unref(extensionSchemaId))
  const enabled = computed(() => !!computedExtensionSchemaId.value)
  const queryKey = computed(() => ['schemas', 'extensionSchema', computedExtensionSchemaId.value])
  return useQuery({
    queryKey,
    queryFn: async (): Promise<CustomFieldsSchema> =>
      await getExtensionSchemaFormatted(computedExtensionSchemaId.value!),
    enabled,
    staleTime: moment.duration(30, 'minutes').asMilliseconds(),
    retry: (failureCount, error: AxiosError) =>
      failureCount < 3 && error.status !== undefined && error.status >= 500,
  })
}
